module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/icon_available_visit-93fe6dafb9b7c0871188d11e32b839b9.svg";